export default [{
    path: '/clients',
    name: 'clients',
    component: () => import('@/views/modules/Clients/index.vue'),
    meta: {
      pageTitle: '',
      breadcrumb: [{
        text: 'navbars.clients',
        active: true,
      }, ],
      action: 'read',
      resource: 'sales',
      unique_name: "clients"
    },
  },
  {
    path: '/clients/:id',
    name: 'clients-datail',
    component: () => import('@/views/modules/Clients/ClientDatail.vue'),
    meta: {
      breadcrumb: [{
          text: 'navbars.clients',
          active: true,
        },
        {
          text: 'navbars.clients_details',
          active: true,
        },
      ],
      action: 'read',
      resource: 'sales',
      unique_name: "clients"
    },
  },
  {
    path: '/clients-demo-page',
    name: 'clients-demo-page',
    component: () => import('@/views/modules/Clients/demoPage.vue'),
    meta: {
      layout: 'full',
      action: 'read',
      resource: 'sales',
    },
    unique_name: "clients-demo-page"
  },
  {
    path: '/clients-flat-choose',
    name: 'clients-flat-choose',
    component: () => import('@/views/modules/Clients/flatChoose.vue'),
    meta: {
      breadcrumb: [{
        text: 'clients.flat_choosing',
        active: true,
      }, ],
      action: 'read',
      resource: 'sales',
    },
  },
]